import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export default function DeleteProject({ handleClick }) {
  return (
    <div className="fixed" style={{ top: "40%", left: "30%" }}>
      <div className="bg-white p-6 w-fit rounded-lg flex max-w-xl">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 mr-5 sm:h-10 sm:w-10">
          <ExclamationTriangleIcon
            className="h-6 w-6 text-red-600"
            aria-hidden="true"
          />
        </div>
        <div>
          <h1 className="text-base font-semibold text-gray-900">
            Delete Project
          </h1>
          <p className="text-sm text-gray-500 mt-2">
            Are you sure you want to delete your project? All of your data will
            be permanently removed. This action cannot be undone.
          </p>
          <div className="px-4 mt-7 flex flex-row-reverse">
            <button
              type="button"
              className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 ml-3 sm:w-auto"
              onClick={() => handleClick("delete")}
            >
              Delete
            </button>
            <button
              type="button"
              className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 w-auto"
              onClick={() => handleClick("cancel")}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
